import { render } from "./Warehouses.vue?vue&type=template&id=6c11b0ad"
import script from "./Warehouses.vue?vue&type=script&lang=js"
export * from "./Warehouses.vue?vue&type=script&lang=js"

import "./Warehouses.vue?vue&type=style&index=0&id=6c11b0ad&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__